__turbopack_context__.v({
  "active": "blog-module__3rPSzG__active",
  "articleModal": "blog-module__3rPSzG__articleModal",
  "articleModalBody": "blog-module__3rPSzG__articleModalBody",
  "articleModalClose": "blog-module__3rPSzG__articleModalClose",
  "articleModalMeta": "blog-module__3rPSzG__articleModalMeta",
  "articleModalPanel": "blog-module__3rPSzG__articleModalPanel",
  "articleModalTitle": "blog-module__3rPSzG__articleModalTitle",
  "blogCard": "blog-module__3rPSzG__blogCard",
  "blogCardBody": "blog-module__3rPSzG__blogCardBody",
  "blogCardBodyText": "blog-module__3rPSzG__blogCardBodyText",
  "blogCardImg": "blog-module__3rPSzG__blogCardImg",
  "blogCardImgLarge": "blog-module__3rPSzG__blogCardImgLarge",
  "blogCardMeta": "blog-module__3rPSzG__blogCardMeta",
  "blogFeatured": "blog-module__3rPSzG__blogFeatured",
  "blogFeaturedBg": "blog-module__3rPSzG__blogFeaturedBg",
  "blogFeaturedContent": "blog-module__3rPSzG__blogFeaturedContent",
  "blogFeaturedOverlay": "blog-module__3rPSzG__blogFeaturedOverlay",
  "blogFilter": "blog-module__3rPSzG__blogFilter",
  "blogFilters": "blog-module__3rPSzG__blogFilters",
  "blogFurtherReading": "blog-module__3rPSzG__blogFurtherReading",
  "blogGridRow1": "blog-module__3rPSzG__blogGridRow1",
  "blogGridRow2": "blog-module__3rPSzG__blogGridRow2",
  "blogHeader": "blog-module__3rPSzG__blogHeader",
  "blogHeaderLeft": "blog-module__3rPSzG__blogHeaderLeft",
  "blogHeaderRight": "blog-module__3rPSzG__blogHeaderRight",
  "blogMeta": "blog-module__3rPSzG__blogMeta",
  "blogNewsletter": "blog-module__3rPSzG__blogNewsletter",
  "blogNewsletterForm": "blog-module__3rPSzG__blogNewsletterForm",
  "blogNewsletterText": "blog-module__3rPSzG__blogNewsletterText",
  "blogPage": "blog-module__3rPSzG__blogPage",
  "blogReadMore": "blog-module__3rPSzG__blogReadMore",
  "blogTag": "blog-module__3rPSzG__blogTag",
  "blogTrending": "blog-module__3rPSzG__blogTrending",
  "blogTrendingItem": "blog-module__3rPSzG__blogTrendingItem",
  "blogTrendingLabel": "blog-module__3rPSzG__blogTrendingLabel",
  "blogTrendingList": "blog-module__3rPSzG__blogTrendingList",
  "blogTrendingNum": "blog-module__3rPSzG__blogTrendingNum",
  "blogTrendingText": "blog-module__3rPSzG__blogTrendingText",
  "btnPrimary": "blog-module__3rPSzG__btnPrimary",
  "dot": "blog-module__3rPSzG__dot",
  "enterprise": "blog-module__3rPSzG__enterprise",
  "featured": "blog-module__3rPSzG__featured",
  "health": "blog-module__3rPSzG__health",
  "industry": "blog-module__3rPSzG__industry",
  "news": "blog-module__3rPSzG__news",
  "page": "blog-module__3rPSzG__page",
  "slideUp": "blog-module__3rPSzG__slideUp",
  "voice": "blog-module__3rPSzG__voice",
});
